import React from 'react';
import { Camera, Database, Lock, Mail, Phone, Shield, Trash2 } from 'lucide-react';
import { CONTACT_EMAIL, WHATSAPP_NUMBER } from '../config/api_config';
import { useLanguage } from '../i18n/LanguageContext';

export default function PrivacyPage() {
  const { t } = useLanguage();

  return (
    <section className="section page-top">
      <div className="container narrow">
        <div className="section-head">
          <div className="icon-badge">
            <Shield size={28} />
          </div>
          <h1>{t.privacy.title}</h1>
        </div>

        <div className="content-panel privacy-grid">
          <div>
            <h2>
              <Database size={18} /> {t.privacy.collectedTitle}
            </h2>
            <ul>
              {t.privacy.collected.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          <div>
            <h2>
              <Lock size={18} /> {t.privacy.storageTitle}
            </h2>
            <ul>
              {t.privacy.storage.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="content-panel">
          <h2>{t.privacy.principlesTitle}</h2>
          <div className="principle-list">
            {t.privacy.principles.map((item, i) => {
              const Icon = [Shield, Camera, Database, Trash2][i] || Shield;
              return (
                <div key={item} className="principle-item">
                  <Icon size={18} />
                  <p>{item}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="contact-row">
          <a
            className="btn btn-soft"
            href={`https://wa.me/${WHATSAPP_NUMBER}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Phone size={16} /> +{WHATSAPP_NUMBER}
          </a>
          <a className="btn btn-soft" href={`mailto:${CONTACT_EMAIL}`}>
            <Mail size={16} /> {CONTACT_EMAIL}
          </a>
        </div>
      </div>
    </section>
  );
}
